import { render, staticRenderFns } from "./JobAssignmentList.vue?vue&type=template&id=9edcfc64"
import script from "./JobAssignmentList.vue?vue&type=script&lang=js"
export * from "./JobAssignmentList.vue?vue&type=script&lang=js"
import style0 from "./JobAssignmentList.vue?vue&type=style&index=0&id=9edcfc64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports